// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"880":"de12ca44","1997":"84998110","3936":"de12ca44","6050":"de12ca44","7223":"de12ca44","8769":"de12ca44"}[chunkId] + ".chunk.css";
};